<template>
  <b-modal v-model="isModalActive" :id="'sideBar'+$store.state.sidebar" :can-cancel="false">
    <div class="form-modal-widget">
      <div class="form-modal-header">
        <h1 v-if="!form.id">ADD NEW VOTING CATEGORY</h1>
        <h1 v-else>EDIT VOTING CATEGORY</h1>
      </div>

      <div class="form-modal-body">
        <div class="row">
          <b-field label="Name" style="width: 100%">
            <b-input v-model="form.name"></b-input>
          </b-field>
        </div>

        <b-field label="Number of winners">
          <b-numberinput v-model="form.winners_number"></b-numberinput>
        </b-field>

        <b-field label="Priority">
          <b-numberinput v-model="form.priority"></b-numberinput>
        </b-field>

        <b-field label="Visibility" style="width: 100%">
          <b-select
            v-model="form.status"
            placeholder="Select a visibility"
            expanded
          >
            <option
              v-for="option in visibilities"
              :value="option.value"
              :key="option.value"
            >
              {{ option.name }}
            </option>
          </b-select>
        </b-field>
      </div>

      <div class="form-modal-footer">
        <b-button
          :loading="submit_loading"
          @click="submitForm()"
          type="is-primary"
        >
          SUBMIT
        </b-button>
        <b-button @click="onCancel" type="is-primary" outlined>CANCEL</b-button>
      </div>
    </div>
  </b-modal>
</template>
  <script>
export default {
  components: {},
  props: {
    session_id: {
      type: Number,
      default: null,
    },
    value: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    isModalActive: true,
    visibilities: [
      {
        value: "public",
        name: "Public",
      },
      {
        value: "unlisted",
        name: "Unlisted",
      },
    ],
    form: {
      id: null,
      session_id: null,
      name: "",
      priority: 1,
      winners_number: 1,
      status: "unlisted",
    },
    submit_loading: false,
  }),
  watch: {},
  mounted() {
    let vm = this;
    if (vm.value) {
      vm.setFormFields();
    } else {
      vm.resetFormFields();
    }
  },
  beforeDestroy() {
    let vm = this;
  },
  methods: {
    setFormFields() {
      let vm = this;
      vm.form.id = vm.value.id;
      vm.form.session_id = vm.value.voting_session_id;
      vm.form.name = vm.value.name;
      vm.form.priority = vm.value.prio;
      vm.form.winners_number = vm.value.winners_number;
      vm.form.status = vm.value.status;
    },
    resetFormFields() {
      let vm = this;
      vm.form = {
        id: null,
        session_id: null,
        name: "",
        priority: 0,
        winners_number: 1,
        status: "unlisted",
      };
    },
    submitForm() {
      let vm = this;
      // Start validate
      const rules = {
        name: {
          run: (value) => {
            if (!value) {
              return "Name is required";
            }
            return false;
          },
        },
      };
      if (vm.$isFieldsValidated(vm.form, rules)) {
        vm.submit_loading = true;
        vm.form.session_id = vm.session_id;
        if (!vm.form.id) {
          vm.$store
            .dispatch("VOTING_ADDNEW_VOTING_CATEGORY", vm.form)
            .then((response) => {
              vm.submit_loading = false;
              vm.$emit("saved", response.data.return);
              vm.$notify({
                group: "status",
                type: "success",
                title: "Important message",
                text: response.data.message,
              });
            })
            .catch(({ response }) => {
              vm.submit_loading = false;
              vm.$notify({
                group: "status",
                type: "warn",
                title: "OOPS!!!",
                text: response.data.message,
              });
            });
        } else {
          vm.$store
            .dispatch("VOTING_UPDATE_VOTING_CATEGORY", vm.form)
            .then((response) => {
              vm.submit_loading = false;
              vm.$emit("saved", response.data.return);
              vm.$notify({
                group: "status",
                type: "success",
                title: "Important message",
                text: response.data.message,
              });
            })
            .catch(({ response }) => {
              vm.submit_loading = false;
              vm.$notify({
                group: "status",
                type: "warn",
                title: "OOPS!!!",
                text: response.data.message,
              });
            });
        }
      }
    },
    onCancel() {
      let vm = this;
      vm.$emit("close");
    },
  },
};
</script>
  <style lang="scss" scoped>
.form-modal-widget {
  width: 600px;
  background: #fff;
  margin: 20px auto;
  border-radius: 5px;
  @media (max-width: 628px) {
    width: 95% !important;
    .row {
      flex-direction: column;
    }
  }
  @media (max-width: 500px) {
    width: 100% !important;
    margin: 0;
  }

  .form-modal-header {
    height: 60px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ddd;
    padding: 0px 20px;
    justify-content: space-between;
    @media (max-width: 500px) {
      position: sticky;
      top: 0;
      z-index: 10;
      background: white;
    }
  }

  .form-modal-body {
    padding: 10px 20px;
    min-height: 200px;
    padding-bottom: 30px;
  }

  .form-modal-footer {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #ddd;
    padding: 0px 20px;
  }
}
#sideBartrue {
  left: 230px;
  @media (max-width: 768px) {
    left: 0;
  }
  .form-modal-widget  {
    @media (max-width: 846px) {
      width: 500px;
    }
    @media (max-width: 768px) {
      width: 600px;
    }
  }
}
</style>
  